import React from 'react';
import moment from 'moment-timezone';

import {
  IconScale,
  IconDna,
  IconVaccine,
  IconClipboardList,
  IconCirclePlus,
  IconRuler2,
  IconCapture,
} from '@tabler/icons';

import { Container } from './styles';

interface IRegisterItem {
  type:
    | 'peso'
    | 'vacinacao'
    | 'inseminacao'
    | 'diagnostico_de_gestacao'
    | 'paricao'
    | 'perimetro_escrotal'
    | 'observacao';
  description: string;
  category?: string;
  date: string;
  onClick?: () => void;
  canEdit?: boolean;
}

const RegisterItem: React.FC<IRegisterItem> = ({
  type,
  description,
  date,
  category,
  onClick,
  canEdit,
}) => {
  const template = {
    peso: {
      icon: <IconScale size={30} color="#999" />,
      title: 'Peso (kg)',
    },
    vacinacao: {
      icon: <IconVaccine size={30} color="#999" />,
      title: 'Vacinação',
    },
    inseminacao: {
      icon: <IconDna size={30} color="#999" />,
      title: 'Inseminação',
    },
    diagnostico_de_gestacao: {
      icon: <IconClipboardList size={30} color="#999" />,
      title: 'Diagnóstico de gestação',
    },
    paricao: {
      icon: <IconCirclePlus size={30} color="#999" />,
      title: 'Parição',
    },
    perimetro_escrotal: {
      icon: <IconRuler2 size={30} color="#999" />,
      title: 'Perímetro escrotal (cm)',
    },
    perimetroEscrotal: {
      icon: <IconRuler2 size={30} color="#999" />,
      title: 'Perímetro escrotal (cm)',
    },
    observacao: {
      icon: <IconCapture size={30} color="#999" />,
      title: 'Observação',
    },
  };

  return (
    <Container onClick={onClick} cursor={canEdit ? 'pointer' : 'default'}>
      <div>
        {template[type]?.icon}
        <div>
          <span>
            {template[type]?.title} {category && <i>{category}</i>}
          </span>
          <strong>{description}</strong>
        </div>
      </div>
      <strong>{moment(date).format('DD[/]MM[/]YYYY')}</strong>
    </Container>
  );
};

export default RegisterItem;
